import React from "react";
import { Field, Form, Formik } from "formik";
import "./EmailModal.scss";
import Modal from "../Modal/Modal";
import { getEmailSchema } from "./validationSchema";
import { TranslatedText } from "../../../helpers/helpers";

const initialValues = {
  email: "",
};

const EmailModal = ({
  isOpen,
  onClose,
  title,
  emailTitle,
  emailPlaceholder,
  btnText,
  btnConfirm,
  email,
  enable,
  disable,
  changeEmailBill,
  disableOblineBill,
  desc,
  info

}) => {
  return isOpen ? (
    <Formik
      initialValues={
        email
          ? {
              email: email,
              isDisabledPress: false,
            }
          : initialValues
      }
      enableReinitialize={true}
      validationSchema={getEmailSchema}
      key={"EmailModal"}
      onSubmit={(value, props) => {
        enable
          ? enable(value.email)
          : value.isDisabledPress
          ? disable()
          : changeEmailBill(value.email);
          document.querySelector("body").classList.remove("modal-open");
      }}
    >
      {({ errors, touched, values, setFieldValue, submitCount }) => (
        <Form>
          <div className="EmailModal" data-testid={"EmailModal"}>
            <Modal
              show={isOpen}
              onClose={onClose}
              noIcon={true}
              ariaLabelled={true}
              titleClass={"text-center"}
              title={title}
              description={desc ? desc : null}
              isWithForm={true}
            >
              <p className={"case-step-mandatory-fields-legend paragraph-small-fs9"}><TranslatedText i18nKey="mandatory.fields.legend"/></p>
              <div
                className={
                  errors.email && touched.email && submitCount > 0
                    ? "form-group has-error"
                    : "form-group"
                }
              >
                <label className="paragraph-small-fs9" htmlFor="email">
                  {emailTitle + " *"}
                </label>
                <Field
                  name={"email"}
                  id="email"
                  type="email"
                  data-testid={"emaiModalField"}
                  className={
                    errors.email && touched.email && submitCount > 0
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  aria-describedby={
                    errors.email && touched.email && submitCount > 0
                      ? "email-error"
                      : null
                  }
                  placeholder={emailPlaceholder}
                />
                {errors.email && touched.email && submitCount > 0 ? (
                  <p
                    className="form-error-text paragraph-small-form"
                    role="alert"
                    id={"email-error"}
                  >
                    {errors.email}
                  </p>
                ) : null}
                </div>
                {info ? <p>{info}</p> : null}
                {email && !disableOblineBill ? (
                  <div className={"modal-lang--cta"}>
                    <button
                      type="submit"
                      onClick={() => {
                        setFieldValue("isDisabledPress", true);
                      }}
                      className={"btn btn-secondary"}
                    >
                      {btnText}
                    </button>
                    <button
                      type="submit"
                      onClick={() => {
                        setFieldValue("isDisabledPress", false);
                      }}
                      className={"btn btn-primary"}
                    >
                      {btnConfirm}
                    </button>
                  </div>
                ) : email && disableOblineBill ? (
                  <div className={"modal-lang--cta"}>
                    <button type="submit" className={"btn btn-primary"}>
                      {btnText}
                    </button>
                  </div>
                ) : (
                  <div className={"modal-lang--cta"}>
                    <button
                      type="submit"
                      className={"btn btn-primary"}
                      onClick={() =>
                        window.dataLayer.push({
                          event: "attivazioneBollettaStep2",
                        })
                      }
                    >
                      {btnText}
                    </button>
                  </div>
                )}
            </Modal>
          </div>
        </Form>
      )}
    </Formik>
  ) : null;
};

export default EmailModal;
